var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"main_title"},[_vm._v(" 学生奖卡 ")]),_c('div',{staticClass:"main"},[_c('Header',{staticClass:"headers"}),_c('AppMain',{staticClass:"appMain"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }